/* import __COLOCATED_TEMPLATE__ from './teammates.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { InboxType } from 'embercom/models/data/inbox/inbox-types';
import { InboxCategory } from 'embercom/models/data/inbox/inbox-categories';
import { SearchableType } from 'embercom/models/data/inbox/searchable-types';
import type IntlService from 'embercom/services/intl';
import type Session from 'embercom/services/session';
import type Inbox from 'embercom/objects/inbox/inboxes/inbox';
import storage from 'embercom/vendor/intercom/storage';
import { type InboxFolder } from 'embercom/objects/inbox/inbox-folder';
import type ViewSummary from 'embercom/objects/inbox/view-summary';
import type InboxCounters from 'embercom/services/inbox2-counters';

interface Args {
  pinnedInboxes: Inbox[];
  addPin: (inbox: Inbox) => void;
  removePin: (inbox: Inbox) => void;
  reorderInboxes: (inboxes: Inbox[], draggedInbox: Inbox) => void;
  isHoverable: boolean;
  customFolders?: InboxFolder[];
  onCreateCustomFolder: () => void;
  togglePin: () => void;
  onCreateView: () => void;
  onEditView: (row: ViewSummary, hidePopover: Function | null) => void;
}

interface Signature {
  Args: Args;
}

export default class Teammates extends Component<Signature> {
  @service declare intercomEventService: any;
  @service declare session: Session;
  @service declare intl: IntlService;
  @service declare inbox2Counters: InboxCounters;

  @tracked openSectionId: string | undefined;

  @tracked isHovering = false;

  entityType = SearchableType.Admin;
  inboxCategory = InboxCategory.Admin;

  constructor(owner: any, args: Args) {
    super(owner, args);
    this.updateSectionId();
  }

  @action
  removePinHandler(inbox: Inbox) {
    this.args.removePin(inbox);
    this.updateSectionId();
  }

  @action
  updateSectionId() {
    let label = `inbox.inbox-list.teammates-accordion-${this.session.workspace.id}`;
    if (this.args.pinnedInboxes.length === 0) {
      this.openSectionId = undefined;
    } else if (storage.get(label) === null || storage.get(label) === true) {
      this.openSectionId = 'section_a';
    } else {
      this.openSectionId = undefined;
    }
  }

  get yourInboxId(): number {
    return this.session.teammate.id;
  }

  get isDisabled() {
    return this.args.pinnedInboxes.length === 0;
  }

  @action trackInboxHover() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'hover',
      object: 'inbox',
      inbox_type: InboxType.Admin,
    });
  }

  @action onSectionDidOpen() {
    this.inbox2Counters.refreshCounters(this.args.pinnedInboxes);
  }

  @action onOpenSectionChange(sectionId: string) {
    if (sectionId === 'section_a') {
      this.openSectionId = sectionId;
      this.intercomEventService.trackAnalyticsEvent({
        action: 'opened',
        place: 'inbox',
        object: 'inbox_list_dropdown_teammates',
        section: 'inbox',
      });
      storage.set(`inbox.inbox-list.teammates-accordion-${this.session.workspace.id}`, true);
    } else {
      this.openSectionId = undefined;
      storage.set(`inbox.inbox-list.teammates-accordion-${this.session.workspace.id}`, false);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::LeftNav::Folders::Default::Teammates': typeof Teammates;
  }
}
